/**
 * Created by Howard on 9/15/2020.
 */


(function($) {
    $('document').ready(function() {
        var requestBooking = $('.request-booking');
        if (requestBooking.length === 0) {
            return; // Abandon this hook if target does not exist
        }

        requestBooking.on('click', function() {
            var postId = $(this).data('post-id');
            var title = $('h2[data-post-id="'+postId+'"]').html();
            $('div.reveal-header > span').html(title);
            $('input#input_4_8').val(postId);
        });

        var mixer = mixitup('#mix-container', {
            multifilter: {
                enable: true
            }
        });

        

        var inputSearch = document.querySelector('[data-ref="input-search"]');
        var keyupTimeout;

        inputSearch.addEventListener('keyup', function() {
            var searchValue;

            if (inputSearch.value.length < 3) {
                searchValue = '';
            } else {
                searchValue = inputSearch.value.toLowerCase().trim();
                mixer.filter(available_classes.join(', ')).then(function() {
                    $('[class*="' + searchValue + '"]').hide();
                    setTimeout(function() { $('[class*="' + searchValue + '"]').show(); }, 20);
                });
            }

            clearTimeout(keyupTimeout);

            keyupTimeout = setTimeout(function() {
                filterByString(searchValue);
            }, 350);
            mixer.filter(available_classes.join(', ')).then(function() {
                $('[class*="' + searchValue + '"]').hide();
                setTimeout(function() { $('[class*="' + searchValue + '"]').show(); }, 20);
            });
        });

        function filterByString(searchValue) {
            if (searchValue) {
                mixer.filter('[class*="' + searchValue + '"]');
            } else {
            mixer.filter('filter', 'all');
            }

            mixer.filter(available_classes.join(', ')).then(function() {
                $('[class*="' + searchValue + '"]').hide();
                setTimeout(function() { $('[class*="' + searchValue + '"]').show(); }, 20);
            });

        }
        
        
    });
})(jQuery);